import { StyleSheet } from 'react-native';

import { COLOR, blackTransparent, lightGrey } from 'utils/colors';

const styles = StyleSheet.create({
    programCell: {
        flex: 1,
        borderRadius: 2,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        paddingVertical: 6,
        overflow: 'hidden',
    },
    programCellStartedOnThePreviousDay: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    programCellEndingOnTheNextDay: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    },
    programCellLive: {
        backgroundColor: lightGrey(0.2),
    },
    programCellPlaying: {
        backgroundColor: COLOR.primary,
    },
    programCellInnerInfo: {
        flex: 1,
        justifyContent: 'space-around',
    },
    programCellInnerInfoCollapsed: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    programCellText: {
        paddingHorizontal: 6,
    },
    programCellTextPlaying: {
        color: COLOR.background,
    },
    programCellInner: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    programTitleCollapsed: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    programTitleCollapsedDot: {
        width: 2,
        height: 2,
        borderRadius: 2,
        backgroundColor: COLOR.NEUTRAL,
    },
    programTitleCollapsedDotIndent: {
        marginRight: 2,
    },
    programTitleCollapsedDotPlaying: {
        backgroundColor: COLOR.BLACK,
    },
    unsubscribedOverlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: blackTransparent(0.5),
    },
    catchupIcon: {
        marginRight: 6,
        width: 18,
        height: 20,
        alignSelf: 'center',
    },
    strtoverIcon: {
        marginRight: 6,
        width: 24,
        height: 24,
        alignSelf: 'center',
    },
    recordingIcon: {
        marginLeft: 0,
        marginRight: 6,
        width: 24,
        height: 24,
        alignSelf: 'center',
    },
    webStickyProgramCell: {
        overflow: 'visible',
        /*
            On web `position: sticky` doesn't work when ancestor has `overflow: hidden`
            clip-path property is used to bypass the restriction
        */
        // @ts-ignore
        '-webkit-clip-path': 'inset(0)', // Safari
        'clip-path': 'inset(0)',
        clip: 'rect(0px, auto, auto, 0px)', // IE11/Edge
    },
    webStickyText: {
        // @ts-ignore
        position: 'sticky',
        alignSelf: 'flex-start',
        left: 6,
        // @ts-ignore
        overflow: 'clip',
        contain: 'paint',
    },
    minimizedTextContainer: {
        width: '100%',
    },
    minimizedText: {
        alignSelf: 'center',
        justifyContent: 'center',
    },
    unsubscribedCell: {
        zIndex: -1,
    },
});

export default styles;
